import React, { useState, useEffect, useRef } from "react";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { Config } from "../../Config";
import { userAccessToken } from "../../helpers";

const LiveTranscription = () => {
  const [transcription, setTranscription] = useState("");
  const [speechToken, setSpeechToken] = useState(null);
  const [isRecognizing, setIsRecognizing] = useState(false);
  const transcriberRef = useRef(null);

  useEffect(() => {
    fetchTokens();
  }, []);

  const fetchTokens = async () => {
    try {
      const response = await fetch(`${Config.apiServerUrl}/transcribe/token`, {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      });

      const data = await response.json();

      if (data?.status === "success") {
        setSpeechToken(data?.speech_token);
      } else {
        console.error("Error fetching token:", data?.message);
      }
    } catch (error) {
      console.error("Error retrieving token:", error);
    }
  };

  const toggleRecognition = () => {
    if (!speechToken) {
      console.log("No valid token available.");
      return;
    }

    if (!isRecognizing) {
      const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
        speechToken,
        "eastus"
      );

      // Enable diarization
      speechConfig.setProperty(
        SpeechSDK.PropertyId.Conversation_Transcription_DiarizationEnabled,
        "true"
      );
      const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

      transcriberRef.current = new SpeechSDK.ConversationTranscriber(
        speechConfig,
        audioConfig
      );

      transcriberRef.current.transcribed = (s, e) => {
        if(e.result.text !== undefined && e.result.text.length > 0) {
           let speakerId = e.result.speakerId || "Unknown";
           if (speakerId === "Guest-1") {
             speakerId = "Doctor";
           } else if (speakerId === "Guest-2") {
             speakerId = "Patient";
           } else {
             speakerId = "Other";
           }
          
          setTranscription(
            (prev) => prev + `${speakerId}: ${e.result.text}\n`
          );
        }
      };

      transcriberRef.current.canceled = (s, e) => {
        console.error(`CANCELED: Reason=${e.reason}`);
        if (e.reason === SpeechSDK.CancellationReason.Error) {
          console.error(`ERROR: ${e.errorDetails}`);
        }
        transcriberRef.current.stopTranscribingAsync();
        setIsRecognizing(false);
      };

      transcriberRef.current.startTranscribingAsync(
        () => setIsRecognizing(true),
        (error) => {
          console.error("Error starting transcription:", error);
          alert("Failed to start transcription. Please try again.");
        }
      );
    } else {
      if (transcriberRef.current) {
        transcriberRef.current.stopTranscribingAsync(
          () => setIsRecognizing(false),
          (error) => console.error("Error stopping transcription:", error)
        );
      }
    }
  };

  return (
    <div>
      <h1>Real-time Transcription with Speaker ID</h1>
      <button onClick={toggleRecognition} disabled={!speechToken}>
        {isRecognizing ? "Stop Recognition" : "Start Recognition"}
      </button>
      <textarea rows="10" cols="50" value={transcription} readOnly />
    </div>
  );
};

export default LiveTranscription;
